module.exports = __webpack_public_path__ + "img/To-Do-app.9b86939c.png";